import React from "react";

export default function Footer() {
  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            {/* Office Address */}
            <div className="col-lg-4 col-md-6">
              <h5 className="text-light mb-4">Office Address</h5>
              <p className="mb-2">
                <a href="tel:+919610415221" className="me-3 text-light">
                  <i className="fa fa-phone-alt me-3" />
                  +91 9610415221
                </a>
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3"></i>
                kotharitourandtravelservices@gmail.com
              </p>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3"></i>
                Vaishali Nagar, Near HP Petrol Pump, Jaipur, Rajasthan – 302021, India
              </p>
              <p className="mt-3 text-light">
                <i className="fa fa-clock me-2"></i>
                <strong>24x7 Support Available</strong>
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-lg-4 col-md-6">
              <h5 className="text-light mb-4">Quick Links</h5>
              <a className="btn btn-link text-light" href="#">
                Home
              </a>
              <a className="btn btn-link text-light" href="#about">
                About Us
              </a>
              <a className="btn btn-link text-light" href="#services">
                Services
              </a>
              <a className="btn btn-link text-light" href="/contact">
                Contact Us
              </a>
            </div>

            {/* Social Media Links */}
            <div className="col-lg-4 col-md-6">
              <h5 className="text-light mb-4">Follow Us</h5>
              <div className="d-flex">
                <a
                  className="btn btn-outline-light btn-social me-2"
                  href="https://www.facebook.com/share/1XcxiyjpRp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social me-2"
                  href="https://x.com/KothariTravels?t=WJkN2QP-bxd1HoczmO3v5Q&s=09"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social me-2"
                  href="https://www.instagram.com/kotharitourandtravels?igsh=ZXNidmN0OXdlaHB0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social me-2"
                  href="https://youtube.com/@kotharitourandtravels?si=5VndEROegybrpDiM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="container-fluid text-center text-light border-top py-4">
          <p className="mb-0">
            ©{" "}
            <a className="text-light border-bottom" href="/">
              2025 Kothari Travels
            </a>
            , All Rights Reserved. Designed by{" "}
            <a
              className="text-light border-bottom"
              href="https://www.linkedin.com/in/kapil-kumar-sangwan-404819215/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kapil Sangwan
            </a>
          </p>
        </div>
      </div>
      {/* Footer End */}
    </div>
  );
}